@layer module {
.google-authenticator-wrapper {
            width: 100%;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
    }

.google-authenticator-steps {
            align-self: stretch;
            margin: 0;
            display: flex;
            flex-flow: column nowrap;
    }

.google-authenticator-secret {
            width: 100%;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
    }

.google-authenticator-secret-value {
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
    }

.google-authenticator-secret-value span {
            overflow-wrap: anywhere;
            text-align: left;
    }
} // layer module










@layer app {
.google-authenticator-wrapper {
            gap: $size-20;
    }

.google-authenticator-steps {
            padding-left: $size-20;
            gap: $size-7-5;
    }

.google-authenticator-qr {
            padding: $size-15;
            border-radius: $size-10;
    }

.google-authenticator-secret {
            gap: $size-7-5;
    }

.google-authenticator-secret-value {
            padding: $size-10 $size-15;
            border-radius: $size-8;
            gap: $size-10;
    }

.google-authenticator-secret-value {
            background: none;
    }

.google-authenticator-steps {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            line-height: $size-19;
    }

.google-authenticator-qr {
            background: var(--banky-white);
            border: 1px solid var(--border-default);
            line-height: 0;
    }

.google-authenticator-secret-label {
            color: var(--text-secondary);
            font-size: var(--font-size-base);
            line-height: $size-16;
    }

.google-authenticator-secret-value {
            border: 1px solid var(--border-default);
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-weight: 500;
    }

.google-authenticator-secret-value span {
            letter-spacing: $size-1-5;
    }

.google-authenticator-copied {
            color: var(--text-link);
            font-size: var(--font-size-base);
            white-space: nowrap;
    }
} // layer app
